export default __webpack_public_path__ + "media/images/icons_fc/doc2-320cc10a45287681f230bd20f12701a7.png";